import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import './CompactProductCardFlag.scss'

type CompactProductCardFlagProps = ComponentPropsWithoutRef<'span'>

const CompactProductCardFlag: FC<CompactProductCardFlagProps> = props => {
  const { className, ...rest } = props

  return (
    <span className={clsx('o-CompactProductCardFlag', className)} {...rest} />
  )
}

export default CompactProductCardFlag
